import * as Yup from 'yup';
export const initialFranchisorValues = {
    areaOfOperation: '',
    secondaryAreaOfOperation: '',
    startDate: undefined,
};
export const franchisorSchema = Yup.object().shape({
    areaOfOperation: Yup.string(),
    secondaryAreaOfOperation: Yup.string(),
    startDate: Yup.date(),
});
//# sourceMappingURL=franchisor.js.map